import { styled } from '@mui/material'
import theme from 'utils/theme'

export const Container = styled('div')`
  display: flex;
  align-items: center;
  border-bottom: 1px solid
    ${
      // @ts-ignore -- ts does not detect palette colors even though they exist
      theme.palette.primary[50]
    };
  min-height: 48px;
  width: 100%;
  padding-left: 16px;
  padding-right: 2px;
`
